<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="fromCommercialisation" :confirm="askConfirm"
                    :params="{operationId: this.operationId, currentSectionId:this.currentSectionId}"
                    :sub-title-ope="this.operationName"
                    :title="$t('Modify') + ' ' + $t('l.s')  + ' ' +  $t('operationLots')"
                    route-back="CommercialisationLotsShow"/>
        <back-arrow v-else :bilan-type="bilanType"
                    :confirm="askConfirm"
                    :params="{operationId: this.operationId, currentSection:this.currentSectionId}"
                    :sub-title-ope="this.operationName"
                    :title="$t('Modify') + ' ' + $t('l.s')  + ' ' +  $t('operationLots')"
                    route-back="OperationShow"/>

      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div class="col">
                  <LotNavigation
                    :lots="operationLots"
                    :current-section.sync="currentSection"
                    :lot-prefix="$t('OperationLot')"
                    :use-value-property="true"
                    :show-new-label="true"
                    :new-label="$t('New')"
                    :operation-lot-label="$t('operationLot')"
                  />
              </div>

              <b-container fluid>
                <b-row>
                  <b-col v-for="(operationLot, index) in operationLots" :key="index + '-content-key'" class="col-md-12">
                    <template v-if="currentSection === index">
                      <operation-lot-component
                        :deletable="index > 0"
                        :etages="etages"
                        :index="index"
                        :lot-number="index + 1"
                        :need-schedule="operationType && operationType !== 'DEFAULT'"
                        :operation-lot="operationLot"
                        :operation-type="operationType"
                        :t-v-a-types="TVATypes"
                        :template-schedule="templateSchedule"
                        :types-lot="typesLot"
                        :is-h-t="isHT"
                        @didChangeValue="didChangeValue"
                        @removedOperationLot="removedOperationLot"/>
                    </template>
                  </b-col>
                </b-row>
              </b-container>

              <div class="d-flex justify-content-end mr-3">
                <b-button class="btn-medium mr-2" variant="outline-primary" @click="addOperationLot">
                  <plus-icon class="mr-1" size="18"/>
                  {{ $t('Add') }} {{ $t('a') }} {{ $t('operationLot') }}
                </b-button>
                <b-button id="validate-btn" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from "../../../services/api"
import OperationLots from "./OperationLots";
import backArrow from "../../../components/b122/BackArrow";
import OperationLotComponent from "./OperationLotComponent.vue";
import { useDirtyTracking } from '../../../composable/useDirtyTrackingLot';
import LotNavigation from "../../../components/LotNavigation";


export default {
  name: "OperationLotsEdit",

  components: {
    OperationLotComponent,
    backArrow,
    OperationLots,
    LotNavigation
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      currentSectionId: this.$route.params.currentSectionId,
      fromCommercialisation: this.$route.params.fromCommercialisation,
      redirectToLotId: this.$route.params.redirectToLotId,
      operationInitialStartDate: null,
      lotLimit: -1,
      operationInitialEndDate: null,
      currentSection: 0,
      operationLotsIdsToRemove: [],
      askConfirm: false,
      TVATypes: [],
      typesLot: [],
      etages: [],
      bilanType: null,
      operationName: null,
      operationType: null,
      templateSchedule: null,
      operationLots: [],
      dirtyTracker: null,
      isHT: false
    }
  },

  created() {
    // Créer l'instance du dirty tracker
    this.dirtyTracker = useDirtyTracking()
  },

  async mounted() {
    await this.fetchData()
    if (this.fromCommercialisation && this.redirectToLotId) {
      let index = this.operationLots.findIndex(lot => lot.id === this.redirectToLotId)
      if (index > -1) {
        this.currentSection = index
      }
    }
  },

  methods: {
    async fetchData() {
      await this.getMaxNbLots()
      await this.getEtages()
      await this.getOperationLots()
      if (this.operationId) {
        await this.getOperation()
      }
      if (this.operationLots.length === 0) {
        this.addOperationLot()
      }
      await this.getTVATypes()
      await this.getTypesLot()
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
            this.operationType = response.data.operationType
            this.templateSchedule = response.data.schedule
            this.isHT = response.data.isHT
            if (this.templateSchedule && this.templateSchedule.hasOwnProperty('id')) {
              this.templateSchedule.id = null
            }
          })
      }
    },

    generateTempId() {
      return 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },

    async didChangeValue(operationLot) {
      const stateChanged = this.dirtyTracker.checkAndMarkDirty(operationLot)

      if (stateChanged) {
        // Vérifier s'il reste des lots dirty pour askConfirm
        const dirtyLots = this.dirtyTracker.getDirtyLots(this.operationLots)
        this.askConfirm = dirtyLots.length > 0
      }
    },

    scrollToElement(fieldId, index) {
      setTimeout(() => {
        const element = document.querySelector(`#${fieldId}-input-${index}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 200);
    },


    async onSubmit() {
      try {
        const result = await this.createOrUpdateOperationLots();
        if (!result) {
          return;
        }
        await this.deleteOperationLots();

        const routeName = this.fromCommercialisation ? 'CommercialisationLotsShow' : 'OperationShow';
        const routeParams = {
          operationId: this.operationId,
          currentSectionId: this.currentSectionId
        };

        await this.$router.push({
          name: routeName,
          params: routeParams
        });

        await this.generateMonthlyCharges();
      } catch (error) {
        console.error('Failed to create or update operation lots:', error);
      }
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },


    async createOrUpdateOperationLots() {
      let index = 0
      let realIndexArray = 0
      for (const operationLot of this.operationLots) {
        if (!operationLot.name.value
          || !operationLot.prixParM2.value
          || !operationLot.surface.value) {
          this.currentSection = index
          this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            noCloseButton: true,
            variant: "danger",
            solid: true,
          })
          this.$forceUpdate()
          return false
        }
        const fieldInvalid = Object.keys(operationLot).find(key => operationLot[key].state === false || (operationLot[key].invalidFeedback !== null && operationLot[key].invalidFeedback !== '' && operationLot[key].invalidFeedback !== undefined));
        if (fieldInvalid) {
          this.scrollToElement(fieldInvalid, index);
          this.$forceUpdate()
          return false
        }
        index++
      }
      const lotsToSave = this.operationLots.filter(lot =>
        lot.isDirty || !lot.id || lot.id.toString().startsWith('temp_')
      );
      let success = true; // Flag pour contrôler le flux en cas d'erreurs
      index = 1
      for (const operationLot of lotsToSave) {
        let data = new FormData()
        data.append('name', operationLot.name.value)
        if (operationLot.comment.value != null) {
          data.append('comment', operationLot.comment.value)
        }
        data.append('prixParM2', operationLot.prixParM2.value)
        data.append('prixVenteTTC', operationLot.prixVenteTTC.value)
        data.append('surface', operationLot.surface.value)
        data.append('etage', operationLot.etage.value)
        data.append('typeLot', operationLot.typeLot.value)
        data.append('lotCoPro', operationLot.lotCoPro.value)
        if (operationLot.debutConstruction.value != null) {
          data.append('debutConstruction', operationLot.debutConstruction.value)
        }
        if (operationLot.finConstruction.value != null) {
          data.append('finConstruction', operationLot.finConstruction.value)
        }
        if (operationLot.sspVente.value != null) {
          data.append('sspVente', operationLot.sspVente.value)
        }
        if (operationLot.acteVente.value != null) {
          data.append('acteVente', operationLot.acteVente.value)
        }
        if (operationLot.percentageTreso.value != null) {
          data.append('percentageTreso', operationLot.percentageTreso.value)
        }
        if (operationLot.pretAcheteur.value != null) {
          data.append('pretAcheteur', operationLot.pretAcheteur.value)
        }
        if (operationLot.depotPermis.value != null) {
          data.append('depotPermis', operationLot.depotPermis.value)
        }
        if (operationLot.accordPermis.value != null) {
          data.append('accordPermis', operationLot.accordPermis.value)
        }
        if (operationLot.schedule.value != null) {
          data.append('schedule', JSON.stringify(operationLot.schedule.value))
        }

        data.append('realDate', operationLot.realDate.value)
        data.append('realDateSSP', operationLot.realDateSSP.value)
        data.append('operationId', this.operationId)
        console.log(this.operationLots.findIndex(lot => lot === operationLot))
        data.append('lotNumber', this.operationLots.findIndex(lot => lot === operationLot) ? (this.operationLots.findIndex(lot => lot === operationLot) + 1).toString() : index.toString())
        data.append('isLoue', operationLot.isLoue.value)
        data.append('isLotVir', operationLot.isLotVir.value)

        if (operationLot.isLoue && operationLot.isLoue.value) {
          const dureeBail = operationLot.dureeBail ? operationLot.dureeBail.value : ''
          const loyersPercus = operationLot.loyersPercus ? operationLot.loyersPercus.value : ''
          const tauxTVA = operationLot.tauxTVA ? operationLot.tauxTVA.value : ''
          const nomLocataire = operationLot.nomLocataire ? operationLot.nomLocataire.value : ''
          const dateFinBail = operationLot.dateFinBail ? operationLot.dateFinBail.value : ''
          const dateButoirResiliation = operationLot.dateButoirResiliation ? operationLot.dateButoirResiliation.value : ''

          data.append('dureeBail', dureeBail)
          data.append('loyersPercus', loyersPercus)
          data.append('tauxTVA', tauxTVA)
          data.append('nomLocataire', nomLocataire)
          data.append('dateFinBail', dateFinBail)
          data.append('dateButoirResiliation', dateButoirResiliation)

        } else {
          data.append('dureeBail', '')
          data.append('loyersPercus', '')
          data.append('tauxTVA', '')
          data.append('nomLocataire', '')
          data.append('dateFinBail', '')
          data.append('dateButoirResiliation', '')
        }

        index++

        let url = 'operationLot';
        const isNewLot = !operationLot.id || operationLot.id.toString().startsWith('temp_');
        if (!isNewLot) {
          url = '/operationLot/' + operationLot.id;
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
            realIndexArray++
            operationLot.isDirty = false;
          })
          .catch((error) => {
            success = false
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: this.currentSectionId,
                  message: error.response.data.message
                }
              })
            } else if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              if (invalidField === "create") {
                this.errorToast(error.response.data.message)
                return
              }

              this.currentSection = realIndexArray
              this.operationLots[realIndexArray][invalidField]['state'] = false
              this.operationLots[realIndexArray][invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)

              const fieldInvalid = Object.keys(operationLot).find(key => operationLot[key].state === false || (operationLot[key].invalidFeedback !== null && operationLot[key].invalidFeedback !== '' && operationLot[key].invalidFeedback !== undefined));
              if (fieldInvalid) {
                this.scrollToElement(fieldInvalid, realIndexArray);
                this.$forceUpdate()
                return false
              }
            }
          })

      }
      return success;
    },

    async deleteOperationLots() {
      for (const operationLotId of this.operationLotsIdsToRemove) {
        await api
          .delete(`/operationLot/${operationLotId}`)
      }
    },

    async getTVATypes() {
      await api
        .get(`/operationLot/getTVATypes`)
        .then(response => {
          this.TVATypes = response.data
        })
    },

    async getMaxNbLots() {
      await api
        .get(`/operationLot/getMaxNbLots`)
        .then(response => {
          this.lotLimit = response.data
        })
    },

    async getTypesLot() {
      await api
        .get(`/operationLot/getTypesLot`)
        .then(response => {
          this.typesLot = response.data
          if(this.isHT){
            this.typesLot = this.typesLot.filter(type => type.isVefa === true)
          } else {
            this.typesLot = this.typesLot.filter(type => type.isVir === true)
          }
        })
    },

    async getEtages() {
      await api
        .get(`/operationLot/getEtages`)
        .then(response => {
          this.etages = response.data
        })
    },

    async getOperationLots() {
      if (this.operationId != null) {
        await this.getInitialDateOperation()
        await this.getOperationLotsFromOperation()
      } else if (this.simulationId != null) {
        await this.getOperationLotsFromSimulation()
      }
    },

    async getOperationLotsFromOperation() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          response.data.forEach(lot => {

            let debutConstruction = null
            if (lot.debutConstruction) {
              debutConstruction = new Date(lot.debutConstruction).toLocaleDateString().split("/").reverse().join("-")
            } else {
              if (this.operationInitialStartDate && this.operationInitialStartDate !== 0) {
                debutConstruction = new Date(this.operationInitialStartDate).toLocaleDateString().split("/").reverse().join("-")
              }
            }

            let finConstruction = null
            if (lot.finConstruction) {
              finConstruction = new Date(lot.finConstruction).toLocaleDateString().split("/").reverse().join("-")
            } else {
              if (this.operationInitialEndDate && this.operationInitialEndDate !== 0) {
                finConstruction = new Date(this.operationInitialEndDate).toLocaleDateString().split("/").reverse().join("-")
              }
            }

            let sspVente = null
            if (lot.sspVente) {
              sspVente = new Date(lot.sspVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let acteVente = null
            if (lot.acteVente) {
              acteVente = new Date(lot.acteVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let pretAcheteur = null
            if (lot.pretAcheteur) {
              pretAcheteur = new Date(lot.pretAcheteur).toLocaleDateString().split("/").reverse().join("-")
            }

            let depotPermis = null
            if (lot.depotPermis) {
              depotPermis = new Date(lot.depotPermis).toLocaleDateString().split("/").reverse().join("-")
            }

            let accordPermis = null
            if (lot.accordPermis) {
              accordPermis = new Date(lot.accordPermis).toLocaleDateString().split("/").reverse().join("-")
            }

            this.operationLots.push({
              isDirty: false, // Lot existant = non modifié
              id: lot.id,
              name: {state: null, invalidFeedback: null, value: lot.name},
              prixParM2: {state: null, invalidFeedback: null, value: lot.prixParM2},
              prixVenteTTC: {state: null, invalidFeedback: null, value: lot.prixVenteTTC},
              typeLot: {state: null, invalidFeedback: null, value: lot.typeLot.value},
              surface: {state: null, invalidFeedback: null, value: lot.surface},
              etage: {state: null, invalidFeedback: null, value: lot.etage.value},
              lotCoPro: {state: null, invalidFeedback: null, value: lot.lotCoPro},
              comment: {state: null, invalidFeedback: null, value: lot.comment},
              percentageTreso: {state: null, invalidFeedback: null, value: lot.percentageTreso},
              debutConstruction: {
                state: null,
                invalidFeedback: null,
                value: debutConstruction
              },
              finConstruction: {
                state: null,
                invalidFeedback: null,
                value: finConstruction
              },
              acteVente: {
                state: null,
                invalidFeedback: null,
                value: acteVente
              },
              sspVente: {
                state: null,
                invalidFeedback: null,
                value: sspVente
              },
              realDate: {state: null, invalidFeedback: null, value: lot.realDate},
              realDateSSP: {state: null, invalidFeedback: null, value: lot.realDateSSP},
              pretAcheteur: {state: null, invalidFeedback: null, value: pretAcheteur},
              depotPermis: {state: null, invalidFeedback: null, value: depotPermis},
              accordPermis: {state: null, invalidFeedback: null, value: accordPermis},
              isLoue: {state: null, invalidFeedback: null, value: lot.isLoue},
              dateFinBail: {state: null, invalidFeedback: null, value: lot.dateFinBail},
              loyersPercus: {state: null, invalidFeedback: null, value: lot.loyersPercus},
              tauxTVA: {state: null, invalidFeedback: null, value: lot.tauxTVA},
              nomLocataire: {state: null, invalidFeedback: null, value: lot.nomLocataire},
              dateButoirResiliation: {state: null, invalidFeedback: null, value: lot.dateButoirResiliation},
              isLotVir: {state: null, invalidFeedback: null, value: lot.isLotVir},
              schedule: {state: null, invalidFeedback: null, value: lot.schedule},
            })
          })
          this.dirtyTracker.initializeLotsTracking(this.operationLots)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getInitialDateOperation() {
      await api
        .get(`/operation/getInitialDateOperation/${this.operationId}`)
        .then(response => {
          this.operationInitialStartDate = response.data.estimatedStartDate
          this.operationInitialEndDate = response.data.estimatedEndDate
        })
        .catch((error) => {

        })
    },

    async getOperationLotsFromSimulation() {
      await api
        .get(`/simulationLot/getAllForSimulation/${this.simulationId}`)
        .then(response => {
          response.data.forEach(lot => {
            this.operationLots.push({
              isDirty: false, // Lot existant = non modifié
              name: {state: null, invalidFeedback: null, value: lot.name},
              prixParM2: {state: null, invalidFeedback: null, value: lot.prixParM2},
              prixVenteTTC: {state: null, invalidFeedback: null, value: lot.prixVenteTTC},
              typeLot: {state: null, invalidFeedback: null, value: lot.typeLot.value},
              surface: {state: null, invalidFeedback: null, value: lot.surface},
              lotCoPro: {state: null, invalidFeedback: null, value: null},
              etage: {state: null, invalidFeedback: null, value: null},
              comment: {state: null, invalidFeedback: null, value: null},
              debutConstruction: {state: null, invalidFeedback: null, value: null},
              finConstruction: {state: null, invalidFeedback: null, value: null},
              acteVente: {state: null, invalidFeedback: null, value: null},
              sspVente: {state: null, invalidFeedback: null, value: null},
              realDate: {state: null, invalidFeedback: null, value: null},
              realDateSSP: {state: null, invalidFeedback: null, value: null},
              percentageTreso: {state: null, invalidFeedback: null, value: null},
              pretAcheteur: {state: null, invalidFeedback: null, value: null},
              depotPermis: {state: null, invalidFeedback: null, value: null},
              accordPermis: {state: null, invalidFeedback: null, value: null},
              isLoue: {state: null, invalidFeedback: null, value: lot.isLoue},
              dateFinBail: {state: null, invalidFeedback: null, value: null},
              loyersPercus: {state: null, invalidFeedback: null, value: lot.loyersPercus},
              tauxTVA: {state: null, invalidFeedback: null, value: lot.tauxTVA},
              nomLocataire: {state: null, invalidFeedback: null, value: lot.nomLocataire},
              dateButoirResiliation: {state: null, invalidFeedback: null, value: lot.dateButoirResiliation},
              isLotVir: {state: null, invalidFeedback: null, value: false},
              schedule: {state: null, invalidFeedback: null, value: null},
            })
          })
          this.dirtyTracker.initializeLotsTracking(this.operationLots)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async addOperationLot() {

      if (this.lotLimit > -1 && this.operationLots.length >= this.lotLimit) {
        this.errorToast("abonnement.limit.lots")
        return
      }

      this.operationLots.push({
        isDirty: true,
        id: this.generateTempId(),
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixParM2:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixVenteTTC:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        typeLot:
          {
            state: null,
            invalidFeedback: null,
            value: this.typesLot[0].value
          },
        surface:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lotCoPro:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        etage:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        comment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        debutConstruction: {
          state: null,
          invalidFeedback: null,
          value: this.operationInitialStartDate && this.operationInitialStartDate !== 0 ? new Date(this.operationInitialStartDate).toLocaleDateString().split("/").reverse().join("-") : null
        },
        finConstruction: {
          state: null,
          invalidFeedback: null,
          value: this.operationInitialEndDate && this.operationInitialEndDate !== 0 ? new Date(this.operationInitialEndDate).toLocaleDateString().split("/").reverse().join("-") : null
        },
        acteVente: {state: null, invalidFeedback: null, value: null},
        sspVente: {state: null, invalidFeedback: null, value: null},
        realDate: {state: null, invalidFeedback: null, value: null},
        realDateSSP: {state: null, invalidFeedback: null, value: null},
        percentageTreso: {state: null, invalidFeedback: null, value: null},
        pretAcheteur: {state: null, invalidFeedback: null, value: null},
        depotPermis: {state: null, invalidFeedback: null, value: null},
        accordPermis: {state: null, invalidFeedback: null, value: null},
        isLoue: {state: null, invalidFeedback: null, value: false},
        dateFinBail: {state: null, invalidFeedback: null, value: null},
        loyersPercus: {state: null, invalidFeedback: null, value: null},
        tauxTVA: {state: null, invalidFeedback: null, value: null},
        nomLocataire: {state: null, invalidFeedback: null, value: null},
        dateButoirResiliation: {state: null, invalidFeedback: null, value: null},
        isLotVir: {state: null, invalidFeedback: null, value: false},
        schedule: {state: null, invalidFeedback: null, value: null},
      })
      this.currentSection = this.operationLots.length - 1
      this.$forceUpdate()
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

      this.successToastAddLot()
    },

    successToastAddLot() {
      this.$bvToast.toast(this.$i18n.t("operationLot.Added"), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    removedOperationLot(operationLot) {
      this.dirtyTracker.cleanupLotHash(operationLot)
      if (operationLot.id) {
        this.operationLotsIdsToRemove.push(operationLot.id)
      }
      this.operationLots.splice(this.operationLots.indexOf(operationLot), 1)
      this.currentSection = 0
      this.$forceUpdate()

    },

    errorToast(message) {
      this.$bvToast.toast(this.$i18n.t(message), {
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operation/components/OperationLotsEdit.vue